export default __webpack_public_path__ + "img/efLzvwAG.cd2e8223.svg";